/**
 * Enum for possible Stoplight Color values. Questions and Answers can have these values
 * @readonly
 */
export enum StoplightColor {
  RED = 1,
  YELLOW = 2,
  GREEN = 3,
  DOES_NOT_APPLY = 9,
  SKIPPED = 0,
}
